
import { Component, Prop, Vue } from 'vue-property-decorator'
import ScriptLoader from '@/utils/ScriptLoader'
import { NavigationGuardNext, Route } from 'vue-router'
import { Card, Collapser } from 'ui-library'
import i18n from '@/i18n'
import { splitPolicyId } from '@/utils/PolicyId'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'
import AdvisorDetails from '@/componentsTenant/AdvisorDetails.vue'

@Component({
  i18n,
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POLICIES).catch((_reason) => Promise.resolve()),
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.PARTNER_PROXY).catch((_reason) => Promise.resolve()),
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POSTBOX).catch((_reason) => Promise.resolve()),
      ScriptLoader.preloadScript(to.params.line === 'motor' ? window.ENV_CONFIG.WEB_COMPONENTS.MOTOR : '').catch(
        (_reason) => Promise.resolve()
      ),
      ScriptLoader.preloadScript(to.params.line === 'life' ? window.ENV_CONFIG.WEB_COMPONENTS.LIFE : '').catch(
        (_reason) => Promise.resolve()
      ),
      ScriptLoader.preloadScript(
        to.params.line === 'liability' || to.params.line === 'bundled-property'
          ? window.ENV_CONFIG.WEB_COMPONENTS.SHUR
          : ''
      ).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POLICIES).catch((_reason) => Promise.resolve()),
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.PARTNER_PROXY).catch((_reason) => Promise.resolve()),
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POSTBOX).catch((_reason) => Promise.resolve()),
      ScriptLoader.unloadScript(from.params.line === 'motor' ? window.ENV_CONFIG.WEB_COMPONENTS.MOTOR : '').catch(
        (_reason) => Promise.resolve()
      ),
      ScriptLoader.unloadScript(from.params.line === 'life' ? window.ENV_CONFIG.WEB_COMPONENTS.LIFE : '').catch(
        (_reason) => Promise.resolve()
      ),
      ScriptLoader.unloadScript(
        from.params.line === 'liability' || from.params.line === 'bundled-property'
          ? window.ENV_CONFIG.WEB_COMPONENTS.SHUR
          : ''
      ).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  components: {
    Card,
    Collapser,
    AdvisorDetails
  }
})
export default class PolicyDetailPage extends Vue {
  private companyNumber!: string
  private policyNumber!: string
  private partnerProxyId: string | null = null
  @Prop({ default: false, type: Boolean })
  private showNoClaimsData!: boolean
  @Prop({ default: false, type: Boolean })
  private showModificationDate!: boolean

  public created(): void {
    ;[this.companyNumber, this.policyNumber] = splitPolicyId(this.$router.currentRoute.params.policyId)

    this.partnerProxyId = getPartnerProxyId()
  }

  private isShurLine(line: string): boolean {
    const shurLines = [
      'accident',
      'building',
      'glass',
      'household',
      'legal-protection',
      'liability',
      'bundled-property'
    ]

    return shurLines.includes(line)
  }

  private isTrue(value: string | boolean) {
    return !!value && value.toString().toLowerCase() === 'true'
  }

  public showShurDetails(line: string): boolean {
    return this.isTrue(window.ENV_CONFIG.FEATURE_FLAGS.SHUR.SHOW_SHUR_DETAILS) && this.isShurLine(line)
  }

  private isLifeContractAndOdsActiv(): boolean {
    return this.$route.params.line === 'life' && this.isTrue(window.ENV_CONFIG.FEATURE_FLAGS.LIFE.USE_ODS_COMPONENTS)
  }

  public get vehicleChangeUrl(): string {
    // append /fahrzeug-wechseln to end of policy detail url
    let targetUrl: string = this.$router.currentRoute.path
    if (!targetUrl.endsWith('/')) {
      targetUrl += '/'
    }
    return targetUrl + 'fahrzeug-wechseln'
  }
}
